export const PlatformReferralSegmentEventProperties = {
  ctaLocation: {
    BANNER: 'banner',
    PROFILEMENU: 'profilemenu'
  },
  device: {
    MOBILE: 'mobile',
    DESKTOP: 'desktop'
  },
  medium: {
    FACEBOOK: 'facebook',
    MESSENGER: 'messenger',
    EMAIL: 'email',
    WEBSHARE: 'webshare'
  }
};
